/* MonGlowUp — interactions du thème */
(function () {
  'use strict';

  /* Galerie produit : changement d'image principale */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-gallery]');
      if (!gallery) return;
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      main.src = thumb.getAttribute('data-full') || thumb.src;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  /* Sélecteur de quantité */
  document.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('[data-qty]').querySelector('input');
      if (!input) return;
      var delta = parseInt(btn.getAttribute('data-qty-btn'), 10);
      var value = parseInt(input.value, 10) + delta;
      input.value = Math.max(1, value);
    });
  });
})();
